import { makeStyles } from '@material-ui/styles'
import { pageTitleCapitalization } from 'lib/typography/capitalization-styles'
import { pageHeaderContainerPadding } from './page-header-layout'

export const useStyles = makeStyles(theme => ({
  headerContainer: {
    display: 'flex',
    ...pageHeaderContainerPadding(theme),
    alignItems: 'center',
  },

  titleContainer: {
    display: 'flex',
    flexGrow: '1',
    flexDirection: 'column',
    paddingLeft: 0,
    [theme.breakpoints.up('sm')]: {
      border: '0 none',
    },
  },
  title: {
    fontWeight: '500',
    fontSize: '30px',
    lineHeight: '42px',
    ...pageTitleCapitalization,
    [theme.breakpoints.down('xs')]: {
      fontSize: '22px',
    },
  },
  actionWrapper: {
    display: 'flex',
    flexDirection: 'row',
    '& > *': {
      marginRight: theme.spacing(2),
      marginBottom: 0,
    },
    '& :last-child': {
      marginRight: 0,
    },
    [theme.breakpoints.only('sm')]: {
      '& > *': {
        marginBottom: theme.spacing(2),
        marginRight: 0,
      },

      '& :first-child': {
        marginBottom: 0,
      },
    },
  },
  dropdown: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
}))
